/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface WorkflowTransitionRequest
 */
export interface WorkflowTransitionRequest {
    /**
     * 
     * @type {Array<number>}
     * @memberof WorkflowTransitionRequest
     */
    bundles?: Array<number>;
    /**
     * 
     * @type {Array<number>}
     * @memberof WorkflowTransitionRequest
     */
    directories?: Array<number>;
    /**
     * 
     * @type {number}
     * @memberof WorkflowTransitionRequest
     */
    job: number;
    /**
     * 
     * @type {number}
     * @memberof WorkflowTransitionRequest
     */
    root: number;
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof WorkflowTransitionRequest
     */
    variables?: { [key: string]: string | undefined; };
}

export function WorkflowTransitionRequestFromJSON(json: any): WorkflowTransitionRequest {
    return WorkflowTransitionRequestFromJSONTyped(json, false);
}

export function WorkflowTransitionRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): WorkflowTransitionRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'bundles': !exists(json, 'bundles') ? undefined : json['bundles'],
        'directories': !exists(json, 'directories') ? undefined : json['directories'],
        'job': json['job'],
        'root': json['root'],
        'variables': !exists(json, 'variables') ? undefined : json['variables'],
    };
}

export function WorkflowTransitionRequestToJSON(value?: WorkflowTransitionRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'bundles': value.bundles,
        'directories': value.directories,
        'job': value.job,
        'root': value.root,
        'variables': value.variables,
    };
}


